import { Context, Effect, Layer, PubSub, Stream } from 'effect'

export type SnackbarVariant = 'default' | 'error'
export type SnackbarEffectEvent = {
  type: 'show'
  message: string
  timeoutMs?: number
  variant?: SnackbarVariant
}
type ShowSnackbarOptions = { timeoutMs?: number; variant?: SnackbarVariant }

type SnackbarService = {
  show: (message: string, timeoutMsOrOptions?: number | ShowSnackbarOptions) => Effect.Effect<null>
  events: Stream.Stream<SnackbarEffectEvent>
}

export class Snackbar extends Context.Service<Snackbar, SnackbarService>()('Snackbar') {}

export const observeSnackbarEvents = Stream.unwrap(
  Effect.map(Effect.service(Snackbar), (snackbar) => snackbar.events)
)

function toShowEvent(
  message: string,
  timeoutMsOrOptions?: number | ShowSnackbarOptions
): SnackbarEffectEvent {
  let options: ShowSnackbarOptions = {}
  if (typeof timeoutMsOrOptions == 'number') {
    options = { timeoutMs: timeoutMsOrOptions }
  } else if (timeoutMsOrOptions != undefined) {
    options = timeoutMsOrOptions
  }

  return {
    type: 'show',
    message,
    timeoutMs: options.timeoutMs,
    variant: options.variant ?? 'default'
  }
}

export function snackbarLayer() {
  return Layer.effect(
    Snackbar,
    Effect.acquireRelease(PubSub.unbounded<SnackbarEffectEvent>(), PubSub.shutdown).pipe(
      Effect.map(
        (events): SnackbarService => ({
          events: Stream.fromPubSub(events),
          show: (message, timeoutMsOrOptions) =>
            PubSub.publish(events, toShowEvent(message, timeoutMsOrOptions)).pipe(Effect.as(null))
        })
      )
    )
  )
}
